import { CoreStakeholdersName } from './name';
import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getStakeholders } from '@api';
import { updateStakeholderReferences } from './_idMap/actions';

export const coreStakeholdersGetAsyncSlice = createGetAsyncSlice({
	httpSagaOptions: {
		successDataActionCreators: [
			updateStakeholderReferences
		]
	},
	name: CoreStakeholdersName,
	receive: true,
	request: false,
	requestHandler: getStakeholders,
	retainDataOnRequest: true
});
